<app-floorplan-item-details
  [floorplanItem]="freeText()"
  [extent]="extent()"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    @if (freeTextForm) {
      <form odxForm [formGroup]="freeTextForm" [disabled]="freeText().locked">
        <odx-form-field i18n-label="@@floorplan.details.freeText.label" label="Freitext">
          <textarea
            formControlName="content"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.freeText.placeholder"
            placeholder="Freitext"
            class="textarea-large"
            (blur)="onContentBlur()"
          ></textarea>
          <ng-template odxFormFieldError>
            <ng-container i18n="@@floorplan.details.freeText.errorMessage.maxLengthExceeded"
              >Maximale Zeichenanzahl überschritten</ng-container
            >
          </ng-template>
        </odx-form-field>

        <div class="free-text-toolbar">
          <button
            type="button"
            odxButton
            variant="secondary"
            size="small"
            class="format-button"
            [disabled]="freeText().locked"
            [odxTooltip]="tooltipTextColor"
            (click)="colorPicker.click()"
          >
            <odx-icon name="edit" size="medium"></odx-icon>
          </button>
          <input #colorPicker type="color" class="hide-color-picker" formControlName="textColor" />
          <button
            type="button"
            odxButton
            variant="secondary"
            size="small"
            class="format-button"
            [disabled]="freeText().locked"
            [odxTooltip]="tooltipTextBold"
            [attr.aria-pressed]="freeTextForm.get('bold')?.value"
            i18n-aria-label="@@floorplan.details.freeText.bold"
            aria-label="Fett"
            (click)="toggleBold()"
          >
            <strong>F</strong>
          </button>
          <button
            type="button"
            odxButton
            variant="secondary"
            size="small"
            class="format-button"
            [disabled]="freeText().locked"
            [odxTooltip]="tooltipTextItalic"
            [attr.aria-pressed]="freeTextForm.get('italic')?.value"
            i18n-aria-label="@@floorplan.details.freeText.italic"
            aria-label="Kursiv"
            (click)="toggleItalic()"
          >
            <em>K</em>
          </button>
          <button
            type="button"
            odxButton
            variant="secondary"
            size="small"
            class="format-button"
            [disabled]="freeText().locked"
            [odxTooltip]="tooltipTextBulletList"
            [attr.aria-pressed]="freeTextForm.get('listType')?.value === freeTextListType.BULLET"
            i18n-aria-label="@@floorplan.details.freeText.bulletList"
            aria-label="Aufzählungsliste"
            (click)="toggleBulletList()"
          >
            •
          </button>
          <button
            type="button"
            odxButton
            variant="secondary"
            size="small"
            class="format-button"
            [disabled]="freeText().locked"
            [odxTooltip]="tooltipTextNumberedList"
            [attr.aria-pressed]="freeTextForm.get('listType')?.value === freeTextListType.NUMBERED"
            i18n-aria-label="@@floorplan.details.freeText.numberedList"
            aria-label="Nummerierte Liste"
            (click)="toggleNumberedList()"
          >
            1.
          </button>

          <odx-form-field class="font-size-field">
            <input
              type="number"
              formControlName="fontSize"
              odxFormFieldControl
              [min]="minFontSize"
              [max]="maxFontSize"
              [odxTooltip]="tooltipTextFontSize"
            />
            <ng-template odxFormFieldError>
              @if (freeTextForm.get("fontSize")?.hasError("required")) {
                <ng-container i18n="@@floorplan.details.freeText.fontSize.error.required"
                  >Bitte eine Schriftgröße eingeben</ng-container
                >
              } @else if (freeTextForm.get("fontSize")?.hasError("min")) {
                <ng-container i18n="@@floorplan.details.freeText.fontSize.error.min">Die Schriftgröße ist zu klein</ng-container>
              } @else if (freeTextForm.get("fontSize")?.hasError("max")) {
                <ng-container i18n="@@floorplan.details.freeText.fontSize.error.max">Die Schriftgröße ist zu groß</ng-container>
              }
            </ng-template>
          </odx-form-field>
        </div>
      </form>
    }
  </div>
</app-floorplan-item-details>
